<div
  [ngClass]="{
    'upload-container': orientation() === MultiUploadOrientation.vertical,
    'upload-container-horizontal':
      orientation() === MultiUploadOrientation.horizontal,
  }"
>
  <input
    type="file"
    id="load-files"
    class="d-none"
    multiple
    accept="image/*"
    [attr.max]="maxFiles()"
    (change)="onFileChange($event)"
  />
  <div
    [ngClass]="{
      'list-container-vertical':
        orientation() === MultiUploadOrientation.vertical,
      'list-container-horizontal':
        orientation() === MultiUploadOrientation.horizontal,
    }"
  >
    @if (files().length) {
      <div
        #uploadContainer
        cdkDropList
        [ngClass]="{
          'image-list': orientation() === MultiUploadOrientation.vertical,
          'image-list-horizontal':
            orientation() === MultiUploadOrientation.horizontal,
        }"
        [cdkDropListOrientation]="
          orientation() === MultiUploadOrientation.horizontal
            ? MultiUploadOrientation.horizontal
            : MultiUploadOrientation.vertical
        "
        (cdkDropListDropped)="drop($event)"
      >
        @for (image of files(); track image; let i = $index) {
          <div
            class="drag-box card"
            cdkDrag
            [ngClass]="{
              'image-item': orientation() === MultiUploadOrientation.vertical,
              'image-item-horizontal':
                orientation() === MultiUploadOrientation.horizontal,
            }"
            [cdkDragBoundary]="uploadContainer"
          >
            <img
              [src]="image.file ? (image.file | fileToUrl) : image.url"
              class="file-image"
              alt="Uploaded Image"
            />
            @if (
              orientation() === MultiUploadOrientation.vertical && image.file
            ) {
              <span class="fw-bold flex-grow-1 file-name d-none d-sm-block">{{
                image.file.name
              }}</span>
            }
            <button
              type="button"
              class="btn btn-sm btn-bg-light d-flex align-items-center"
              (click)="removeImage(i)"
            >
              <ui-keenicon
                [name]="'cross-circle'"
                class="fs-3 text-danger"
              ></ui-keenicon>
            </button>
          </div>
        }
      </div>
    }
    @if (files().length < maxFiles()) {
      <label
        for="load-files"
        class="card"
        [ngClass]="{
          'add-button-vertical':
            orientation() === MultiUploadOrientation.vertical,
          'add-button-horizontal':
            orientation() === MultiUploadOrientation.horizontal,
        }"
        (dragover)="onDragOver($event)"
        (drop)="onDrop($event)"
      >
        <button
          class="btn add-button-icon btn-sm btn-bg-light d-flex align-items-center"
        >
          <ui-keenicon
            [name]="'plus-circle'"
            class="fs-3 text-primary m-0"
          ></ui-keenicon>
        </button>
      </label>
    }
  </div>
</div>
<div class="form-text">
  {{ description() }}
</div>
